/**
 * Назва етапу бейджем у тоні етапу (`stageTone`, `pipeline.ts`; рішення власника 27.10): одна
 * розмітка для списку, дошки й «Деталей». Тону немає (прибраний відкритий етап,
 * невідомий ключ) — звичайний бейдж. Назва — завжди текстом: колір лише підсилює її (WCAG 1.4.1).
 */
import { type StageTone, stageToneClass } from './pipeline.ts';

export function StageBadge({ label, tone }: { label: string; tone: StageTone | undefined }) {
  const cls = stageToneClass(tone);
  return (
    <span
      className={cls ? `badge stage-badge ${cls}` : 'badge stage-badge'}
      data-stage-tone={tone ?? 'none'}
    >
      <span className="truncate">{label}</span>
    </span>
  );
}
